import crypto from "crypto-js";  //加密模块
const key = "key";  // 秘钥

export default {
    encrypt(data){  //加密
        return crypto.AES.encrypt(JSON.stringify(data),key);
    },
    decrypt(text){  //解密
        if(!text){
            return;
        }
        let bytes = crypto.AES.decrypt(text.toString(),key);
        return JSON.parse( bytes.toString(crypto.enc.Utf8) );
    },
}


// WEBPACK FOOTER //
// ./src/control/crypto.js